"use client"

import { useState } from "react"
import { Menu, X, Sun, Moon } from "lucide-react"
import { Link } from "react-router-dom"
import BrandWordmark from "./common/BrandWordmark"
import { useTheme } from "../context/ThemeContext"

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const { darkMode, toggleDarkMode } = useTheme()

  return (
    <header className="fixed top-0 w-full bg-white/95 dark:bg-gray-900/95 backdrop-blur-sm border-b border-gray-200 dark:border-gray-700 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
  <div className="flex justify-between items-center h-20">
          <div className="flex items-center">
            <Link to="/" className="flex items-center gap-3">
              <BrandWordmark className="h-16 w-16 sm:h-20 sm:w-20" />
            </Link>
          </div>

          <nav className="hidden md:flex space-x-8">
            <a href="#features" className="text-gray-700 dark:text-gray-300 hover:text-blue-600 transition-colors">
              Features
            </a>
            <a href="#pricing" className="text-gray-700 dark:text-gray-300 hover:text-blue-600 transition-colors">
              Pricing
            </a>
            <Link to="/about" className="text-gray-700 dark:text-gray-300 hover:text-blue-600 transition-colors">
              About
            </Link>
            <Link to="/contact" className="text-gray-700 dark:text-gray-300 hover:text-blue-600 transition-colors">
              Contact
            </Link>
          </nav>

          <div className="hidden md:flex items-center space-x-4">
            <button
              onClick={toggleDarkMode}
              className="p-2 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
              title={darkMode ? "Switch to light mode" : "Switch to dark mode"}
              aria-label={darkMode ? "Switch to light mode" : "Switch to dark mode"}
              type="button"
            >
              {darkMode ? (
                <Sun className="w-5 h-5 text-yellow-400" />
              ) : (
                <Moon className="w-5 h-5 text-gray-700" />
              )}
            </button>
            <Link to="/login" className="text-gray-700 dark:text-gray-300 hover:text-blue-600 transition-colors">Sign In</Link>
            <Link to="/register" className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors">Start Free Trial</Link>
          </div>

          <button className="md:hidden text-gray-700 dark:text-gray-200" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white dark:bg-gray-800 border-t dark:border-gray-700">
              <a href="#features" className="block px-3 py-2 text-gray-700 dark:text-gray-300">
                Features
              </a>
              <a href="#pricing" className="block px-3 py-2 text-gray-700 dark:text-gray-300">
                Pricing
              </a>
              <Link to="/about" className="block px-3 py-2 text-gray-700 dark:text-gray-300">
                About
              </Link>
              <Link to="/contact" className="block px-3 py-2 text-gray-700 dark:text-gray-300">
                Contact
              </Link>
              <div className="px-3 py-2 space-y-2">
                <button
                  onClick={toggleDarkMode}
                  className="w-full text-left px-3 py-2 rounded-lg border border-gray-200 dark:border-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors flex items-center gap-2"
                  type="button"
                >
                  {darkMode ? <Sun className="w-4 h-4 text-yellow-400" /> : <Moon className="w-4 h-4" />}
                  <span>{darkMode ? "Light Mode" : "Dark Mode"}</span>
                </button>
                <Link to="/login" className="block w-full text-left text-gray-700 dark:text-gray-300">Sign In</Link>
                <Link to="/register" className="block w-full bg-blue-600 text-white px-4 py-2 rounded-lg">Start Free Trial</Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  )
}
